import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfViewerComponent } from './pdf-viewer.component';
import { MaterialModule } from '../../material/material.module';



@NgModule({
  declarations: [PdfViewerComponent],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports:[
    PdfViewerComponent
  ]
})
export class PdfViewerModule { }
